import {Component, ElementRef, Injector, OnInit, ViewChild} from '@angular/core';
import {BaseComponent} from '../../base.component';
import {RequestType} from '../../../enums/request.type';
import {ListResponse} from '../../../network/service/list.response';
import {RouteUtil} from '../../../util/route.util';
import {Config} from '../../../common/config';
import {isPlatformBrowser} from '@angular/common';

@Component({
  selector: 'app-facility-chooser',
  standalone: false,
  templateUrl: './facility-chooser.component.html',
  styleUrl: './facility-chooser.component.scss'
})
export class FacilityChooserComponent extends BaseComponent implements OnInit {
  @ViewChild('videoElement')
  video!: ElementRef<HTMLVideoElement>;
  videoIds = Config.domain.Details?.Videos ?? [];
  randomVideoUrl = '';
  branches?: any;
  protected readonly Config = Config;

  constructor(injector: Injector) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.setRandomVideo();
  }

  setRandomVideo() {
    this.randomVideoUrl = this.getRandomVideoUrl();
    if (isPlatformBrowser(Config.platformId)) {
      this.playVideoWithRetry();
    }
  }

  playVideoWithRetry(retries = 10, delay = 200) {
    if (retries <= 0) {
      return;
    }
    setTimeout(() => {
      if (this.video?.nativeElement) {
        const videoElement = this.video.nativeElement;
        videoElement.muted = true;
        const playPromise = videoElement.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {
            this.playVideoWithRetry(retries - 1, delay * 2);
          });
        } else {
          this.playVideoWithRetry(retries - 1, delay * 2);
        }
      } else {
        this.playVideoWithRetry(retries - 1, delay * 2);
      }
    }, delay);
  }

  getRandomVideoUrl(): string {
    if (!this.videoIds?.length) return '';
    const randomIndex = Math.floor(Math.random() * this.videoIds.length);
    const randomId = this.videoIds[randomIndex];
    return this.formatVideo(randomId);
  }

  onDetailClick(index: number) {
    const branch = this.branches[index];
    const firstPage = branch.Details?.FirstPage;
    this.router.navigate([RouteUtil.CLIENT_MODULE, firstPage === "LANDING" ? RouteUtil.LANDING_COMPONENT : RouteUtil.MENU_COMPONENT, branch.UniqueIdentifier]).then();
  }

  override loadOnline() {
    super.loadOnline();
    this.serviceApi.getBranches(undefined, undefined, undefined, RequestType.ALL, undefined).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        this.branches = res.data!;
      }
    });
  }
}
